import { render, staticRenderFns } from "./DialogUpdatePermitFee.vue?vue&type=template&id=0005c374&"
import script from "./DialogUpdatePermitFee.vue?vue&type=script&lang=js&"
export * from "./DialogUpdatePermitFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports